import { Search, Calculator, Clipboard, BarChart3 } from "lucide-react";

const tools = [
  {
    icon: Search,
    name: "Recursos de validación",
    description: "Apoyo para evaluar ideas y productos antes de invertir tiempo y recursos.",
  },
  {
    icon: Calculator,
    name: "Herramientas de análisis",
    description: "Recursos para calcular, proyectar y tomar decisiones con más criterio.",
  },
  {
    icon: Clipboard,
    name: "Plantillas de operación",
    description: "Apoyo para organizar pedidos, inventario y seguimiento de forma estructurada.",
  },
  {
    icon: BarChart3,
    name: "Recursos de seguimiento",
    description: "Herramientas complementarias para monitorear y optimizar tu proceso.",
  },
];

export default function ToolsSection() {
  return (
    <section
      id="herramientas"
      data-testid="tools-section"
      className="py-20 md:py-28 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Content */}
          <div>
            <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#0F3D56] mb-4 block">
              Más que contenido
            </span>
            <h2
              className="text-3xl md:text-5xl font-semibold text-[#111827] mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Herramientas que complementan la ruta
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-10">
              La propuesta no se percibe solo como contenido grabado. Incluye recursos 
              digitales y herramientas complementarias de apoyo para validación, análisis, 
              operación y seguimiento de tu proyecto de ecommerce.
            </p>

            {/* Tools List */}
            <div className="space-y-6">
              {tools.map((tool, index) => (
                <div
                  key={index}
                  data-testid={`tool-item-${index}`}
                  className="flex gap-5 group"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-[#0F3D56]/10 flex items-center justify-center group-hover:bg-[#0F3D56] transition-colors duration-300">
                    <tool.icon size={22} className="text-[#0F3D56] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-[#111827] mb-1">
                      {tool.name}
                    </h3>
                    <p className="text-sm text-gray-500">
                      {tool.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Note */}
            <p className="text-xs text-gray-400 mt-8">
              Las herramientas complementarias forman parte de la propuesta educativa provista por MINED.
            </p>
          </div>

          {/* Right Column - Visual */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&auto=format&fit=crop&q=80"
                alt="Herramientas digitales para ecommerce"
                className="w-full rounded-sm shadow-2xl"
              />
              
              {/* Floating Card */}
              <div className="absolute -bottom-6 -left-6 bg-white p-6 shadow-xl border border-gray-100 max-w-xs">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 bg-[#0F3D56]/10 flex items-center justify-center">
                    <Clipboard size={20} className="text-[#0F3D56]" />
                  </div>
                  <span className="text-sm font-bold text-[#111827]">Recursos de apoyo</span>
                </div>
                <p className="text-sm text-gray-500">
                  Herramientas disponibles dentro de la propuesta educativa.
                </p>
              </div>
            </div>

            {/* Background decoration */}
            <div className="absolute -top-8 -right-8 w-64 h-64 bg-[#D4C4A8]/10 -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
